// EpiServer page is probably wrongly configured if this is needed (or BE bug)
// <html> tag should have lang="language-market"
const DEFAULT_FALLBACK_MARKET_LANG = 'en-se';

const shortMarketLangMap = {
    'sv': 'sv-se',
    'no': 'no-no',
    'fi': 'fi-fi',
    'da': 'da-dk',
    'en': 'en-se',
    'fr': 'fr-fr',
}
const getMarketLang = (marketLang) => {
    if (typeof shortMarketLangMap[marketLang] === 'undefined') {
        return `${marketLang}-${marketLang}`;
    }
    return shortMarketLangMap[marketLang];
}

const init = () => {
    const form = document.querySelector('.footer-markets');
    const submitBtns = document.querySelectorAll('.footer-markets__submit');
    if (!form) {
        return;
    }
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        window.location.href = $('.footer-market-language:visible select').val();
    });

    let marketLang = document.querySelector('html').getAttribute('lang').toLocaleLowerCase();

    // EpiServer page is probably wrongly configured if this is needed (or BE bug)
    // <html> tag should always have lang="language-market"
    if (!marketLang) {
        marketLang = DEFAULT_FALLBACK_MARKET_LANG;
    }
    const currentMarket = marketLang.split('-').length > 1 ? marketLang.split('-')[1] : getMarketLang(marketLang).split('-')[1];

    const marketCustomSelect = document.querySelector('.footer-markets__select');
    if (marketCustomSelect !== null) {
        const marketSelect = marketCustomSelect.querySelector('select');
        marketCustomSelect.classList.add(`market-${currentMarket}`);
        marketSelect.value = currentMarket;
        marketSelect.dispatchEvent(new Event('change'));

        const languageSelects = document.querySelectorAll('.new-footer-language-select');

        marketSelect.addEventListener('change', (e) => {
            marketCustomSelect.classList.remove(...marketCustomSelect.classList);
            marketCustomSelect.classList.add('footer-markets__select');
            marketCustomSelect.classList.add('custom-select');
            marketCustomSelect.classList.add(`market-${e.target.value}`);
            submitBtns.forEach((submitBtn) => {
                submitBtn.style.opacity = '1';
            });
        });

        languageSelects.forEach((select) => {
            select.addEventListener('change', () => {
                submitBtns.forEach((submitBtn) => {
                    submitBtn.style.opacity = '1';
                });
            });
        });
    }
}

export default init;
